import { Map } from 'immutable';

export const METRICS_INFO = new Map({
  score: 'Score',
  firstInteractive: 'Interactive',
  speedIndex: 'Speed Index',
  firstContentfulPaint: 'First Contentful Paint',
});

export const JANK_METRICS_INFO = new Map({
  score: 'Jank Score',
  scrollTime: 'Scroll Time',
});

export const PERFORMANCE_ERROR_CAPTION = 'Failed to capture performance metrics';

export const REGRESSION_REASON = {
  NEW_REGIME: 'new_regime',
  BASELINE: 'baseline',
};

export const REGRESSION_CONTENT = new Map({
  new_regime: new Map({
    label: 'Adjust Baseline',
    loadingLabel: 'Adjusting Baseline',
    tooltip: 'Performance Regression issue detected',
  }),
  baseline: new Map({
    label: 'Discard Data',
    loadingLabel: 'Discarding Data',
    tooltip: 'Performance data is beyond the established baseline for this test',
  }),
});

export const ROOT_CAUSE_TYPE = Object.freeze({
  START: 'START',
  MIDDLE: 'MIDDLE',
  END: 'END',
  SINGLE: 'SINGLE',
});
